import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdDataOptions } from '@onefootprint/fetch-dashboard';
import type { DataIdentifier, DocumentKind } from '@onefootprint/request-types';
import { useQuery } from '@tanstack/react-query';
import useEntityVault from '@/components/entities/hooks/use-entity-vault';
import getDocumentDataLabelOrdering from '@/utils/get-document-data-label-ordering';
import getRelevantNonDocumentKeys from '../utils/get-relevant-non-document-keys';
const useSeqnoIdentityData = t0 => {
  const $ = _c(25);
  const {
    fpId,
    seqno,
    documentKind
  } = t0;
  let t1;
  if ($[0] !== fpId || $[1] !== seqno) {
    t1 = getEntitiesByFpIdDataOptions({
      path: {
        fpId
      },
      query: {
        seqno
      }
    });
    $[0] = fpId;
    $[1] = seqno;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !!fpId;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: entityAttributes
  } = useQuery(t3);
  let t4;
  if ($[6] !== entityAttributes || $[7] !== fpId || $[8] !== seqno) {
    t4 = {
      entityAttributes,
      entityId: fpId,
      seqno
    };
    $[6] = entityAttributes;
    $[7] = fpId;
    $[8] = seqno;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const vault = useEntityVault(t4);
  let isAllDecrypted;
  let sortedDis;
  let t5;
  if ($[10] !== documentKind || $[11] !== entityAttributes || $[12] !== vault) {
    const entityDis = entityAttributes?.map(_temp) ?? [];
    const relevantKeys = getRelevantNonDocumentKeys(documentKind);
    const relevantDis = relevantKeys.filter(di => entityDis.includes(di));
    sortedDis = [...relevantDis].sort(_temp2) as DataIdentifier[];
    let t6;
    if ($[16] !== vault) {
      t6 = di_0 => vault.isDecrypted(di_0 as DataIdentifier);
      $[16] = vault;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    isAllDecrypted = relevantDis.every(t6);
    let t7;
    if ($[18] !== vault) {
      t7 = di_1 => vault.isDecryptable(di_1);
      $[18] = vault;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    t5 = relevantDis.every(t7);
    $[10] = documentKind;
    $[11] = entityAttributes;
    $[12] = vault;
    $[13] = isAllDecrypted;
    $[14] = sortedDis;
    $[15] = t5;
  } else {
    isAllDecrypted = $[13];
    sortedDis = $[14];
    t5 = $[15];
  }
  const canDecrypt = t5;
  let t6;
  if ($[20] !== canDecrypt || $[21] !== isAllDecrypted || $[22] !== sortedDis || $[23] !== vault) {
    t6 = {
      vault,
      isDecrypted: isAllDecrypted,
      canDecrypt,
      dis: sortedDis
    };
    $[20] = canDecrypt;
    $[21] = isAllDecrypted;
    $[22] = sortedDis;
    $[23] = vault;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
export default useSeqnoIdentityData;
function _temp(attr) {
  return attr.identifier;
}
function _temp2(a, b) {
  return getDocumentDataLabelOrdering(a) - getDocumentDataLabelOrdering(b);
}